import { render, staticRenderFns } from "./control-button.vue?vue&type=template&id=abb34732&scoped=true"
import script from "./control-button.vue?vue&type=script&lang=ts&setup=true"
export * from "./control-button.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./control-button.vue?vue&type=style&index=0&id=abb34732&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb34732",
  null
  
)

export default component.exports